/*
 * @Descripttion: 党政风
 * @Author: shenah
 * @Date: 2023-07-19 09:06:56
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:37:38
 */

export default {
  name: "党政风",
  value: "redStyle",
  picture: "eb40fb8aa5cf41968bae408e2623a1b4",
  style: {
    //页面
    dataviewPage: {
      //字体颜色
      fontColor: "#FFFFFF",
      //页面背景
      backgroundConfig: {
        active: "color",
        pattern: {
          image: "",
        },
        color: {
          type: "radial",
          image:
            "radial-gradient(ellipse closest-corner at 50%42%, rgb(255, 255, 255) 0%,rgba(141, 0, 22, 1) 41%)",
          isTheme: false,
          theme: "main",
          value: "rgba(141, 0, 22, 1)",
        },
        radial: {
          size: "closest-corner",
          position: [50, 42],
          point: [
            {
              length: 0,
              color: "rgb(255, 255, 255)",
              show: false,
              active: false,
            },
            {
              length: 41,
              color: "rgba(141, 0, 22, 1)",
              active: false,
              show: true,
            },
          ],
          shape: "ellipse",
        },
      },
    },
    // 选中与未选中的样式
    dataViewSelectStyle: {
      defaultColor: "#fff",
      clickColor: "#FFDC4C",
    },
    //面板标题
    dataviewPanelText: {
      backgroundConfig: {
        active: "color",
        color: {
          type: "linear",
          image:
            "linear-gradient(270deg, rgb(255, 255, 255) 14%,rgba(183, 98, 23, 1) 100%)",
          isTheme: false,
          theme: "main",
          value: "rgba(183, 98, 23, 1)",
        },
        linear: {
          angle: 270,
          point: [
            {
              length: 14,
              color: "rgb(255, 255, 255)",
              active: false,
            },
            {
              length: 100,
              color: "rgba(183, 98, 23, 1)",
              active: false,
            },
          ],
        },
      },
      //标题颜色
      titleColor: "#ffffff",
      subTitleColor: "#ffffff",
    },
    //面板组件
    dataviewPanel: {
      //标题背景
      titleBackgroundConfig: {
        active: "color",
        color: {
          type: "linear",
          image:
            "linear-gradient(270deg, rgb(255, 255, 255) 14%,rgba(183, 98, 23, 1) 100%)",
          isTheme: false,
          theme: "main",
          value: "rgba(183, 98, 23, 1)",
        },
        linear: {
          angle: 270,
          point: [
            {
              length: 14,
              color: "rgb(255, 255, 255)",
              active: false,
            },
            {
              length: 100,
              color: "rgba(183, 98, 23, 1)",
              active: false,
            },
          ],
        },
      },
      //标题颜色
      titleColor: "#ffffff",
      //子标题
      subTitleColor: "#ffffff",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //头部横栏
    dataviewHeaderContent: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "c1d1d56a31c1407eaf4ff1729ba7ba5c",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#ffffff",
      //子标题
      subTitleColor: "#ffffff",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //表格组件
    dataviewTable: {
      barColors: ["#FFF49F"], // 柱体的背景色
      prop_headerBGC: "", // 统一的表头背景色
      prop_headerColor: "#FFF49F", // 统一的表头颜色
      contentColor: "#FFF49F", // 统一的内容颜色
    },
    //图表组件
    dataviewGraph: {
      // 标题
      title: {
        labelColor: "#FFF49F",
      },
      // 图例
      legend: {
        labelColor: "#FFF49F",
      },
      // 坐标系颜色控制
      axis: {
        labelColor: "rgba(223, 174, 120, 1)",
        lineColor: "rgba(171, 97, 109, 1)",
      },
      // 地图颜色设置
      map: {
        colors: ["rgba(225,149,139,1)"], // 地图区域颜色
        labelColor: "#439ea4", // 地图文字颜色
        borderColor: "rgba(146,124,140,1)", // 地图边线文字
      },
      // 图形颜色设置
      commonStyle: {
        colors: [
          [
            "rgba(255,244,159,0.2)",
            "rgba(255,244,159,0.6)",
            "rgba(255,244,159,1)",
          ],
          [
            "rgba(255,220,76,0.2)",
            "rgba(255,220,76,0.6)",
            "rgba(255,220,76,1)",
          ],
          [
            "rgba(255,107,71,0.2)",
            "rgba(255,107,71,0.6)",
            "rgba(255,107,71,1)",
          ],
          ["rgba(0,242,189,0.2)", "rgba(0,242,189,0.6)", "rgba(0,242,189,1)"],
          ["rgba(0,185,249,0.2)", "rgba(0,185,249,0.6)", "rgba(0,185,249,1)"],
          [
            "rgba(59,162,114,0.2)",
            "rgba(59,162,114,0.6)",
            "rgba(59,162,114,1)",
          ],
          [
            "rgba(91,110,150,0.2)",
            "rgba(91,110,150,0.6)",
            "rgba(91,110,150,1)",
          ],
        ],
        labelColor: "#FFF49F",
      },
    },
    //图文组件
    dataviewKeyTrades: {
      backgroundConfigs: [], // 单个背景(里面对象则为背景的通用对象)
      attachObj: {
        // 统一
        nameColor: "#FFF49F", // 名称颜色
        valueColor: "#FFDC4C", // 值颜色
        unitColor: "#FFDC4C", // 单位颜色
      },
    },
  },
};
